<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Beállítások</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="beallitasok">

    <ion-card>
      <ion-card-header>
        <ion-card-title>Megjelenés</ion-card-title>
        <ion-card-subtitle>Modulonként választhatod a kinézetet. Ha nem választasz, az intézmény alapértelmezése érvényes – azt az adminisztrátor jelöli ki.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <p class="halvany" *ngIf="!modulok.length">Nincs olyan modulod, amelyikben választható a téma.</p>
        <div class="modul" *ngFor="let m of modulok">
          <div class="modul-fej">
            <img [src]="m.ikon" alt="" width="28" height="28">
            <span class="modul-nev">{{ m.nev }}</span>
            <span class="cimke" *ngIf="m.aktualis">most ezt használod</span>
          </div>
          <div class="valaszto" role="radiogroup" [attr.aria-label]="m.nev + ' témája'">
            <button type="button" role="radio" [attr.aria-checked]="!valasztott(m.kod)" [class.aktiv]="!valasztott(m.kod)"
                    [disabled]="fut" (click)="temaValaszt(m.kod, null)">
              <ion-icon name="business-outline"></ion-icon>
              <span><b>Intézményi alapértelmezés</b><small>most: {{ m.alapNev }}</small></span>
            </button>
            <button type="button" role="radio" [attr.aria-checked]="valasztott(m.kod) === 'klasszikus'" [class.aktiv]="valasztott(m.kod) === 'klasszikus'"
                    [disabled]="fut" (click)="temaValaszt(m.kod, 'klasszikus')">
              <ion-icon name="browsers-outline"></ion-icon>
              <span><b>Klasszikus</b><small>bal oldali menüsáv</small></span>
            </button>
            <button type="button" role="radio" [attr.aria-checked]="valasztott(m.kod) === 'fokusz'" [class.aktiv]="valasztott(m.kod) === 'fokusz'"
                    [disabled]="fut" (click)="temaValaszt(m.kod, 'fokusz')">
              <ion-icon name="scan-outline"></ion-icon>
              <span><b>Fókusz</b><small>felső sáv, letisztult felület</small></span>
            </button>
          </div>
        </div>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="szinmodLathato">
      <ion-card-header>
        <ion-card-title>A menü és a fejléc színe</ion-card-title>
        <ion-card-subtitle>Az iskolai rendszer Fókusz témájában. A tartalom mindig világos marad.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="valaszto" role="radiogroup" aria-label="A menü és a fejléc színe">
          <button type="button" role="radio" [attr.aria-checked]="szinmod === 'rendszer'" [class.aktiv]="szinmod === 'rendszer'"
                  [disabled]="fut" (click)="szinmodValaszt('rendszer')">
            <ion-icon name="contrast-outline"></ion-icon><span><b>Rendszer szerint</b><small>a gép beállítását követi</small></span>
          </button>
          <button type="button" role="radio" [attr.aria-checked]="szinmod === 'sotet'" [class.aktiv]="szinmod === 'sotet'"
                  [disabled]="fut" (click)="szinmodValaszt('sotet')">
            <ion-icon name="moon-outline"></ion-icon><span><b>Sötét</b><small>sötét menü és fejléc</small></span>
          </button>
          <button type="button" role="radio" [attr.aria-checked]="szinmod === 'vilagos'" [class.aktiv]="szinmod === 'vilagos'"
                  [disabled]="fut" (click)="szinmodValaszt('vilagos')">
            <ion-icon name="sunny-outline"></ion-icon><span><b>Világos</b><small>fehér menü és fejléc</small></span>
          </button>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
